import { Link } from "react-router-dom";
import { useTitle } from "../hooks/useTitle";

export default function NotFoundPage() {
  useTitle("Page Not Found | HairByYaya");
  return <div className="min-h-[70vh] px-5 pb-24 pt-40"><div className="mx-auto max-w-6xl"><p className="font-script text-3xl text-hotpink">oops</p><h1 className="mt-2 font-serif text-5xl md:text-7xl">That page wandered off.</h1><p className="mt-6 text-white/55">Let’s get you somewhere beautiful.</p><Link to="/" className="mt-8 inline-flex rounded-full bg-hotpink px-8 py-3.5 text-xs font-bold uppercase tracking-[0.2em] text-white">Back home</Link></div></div>;
}
